import {
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Stack,
} from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import { MyIconButton, MyTypography } from '../../../common/components';
import { IconArrowDown, IconArrowUp, IconX } from '@tabler/icons';
import MyTextField from '../../../common/components/MyTextField';
import ChoicesOptions from '../ChoicesOptions';
import {
  DEFAULT_ORIGINAL_FIELDS,
  FIELD_TYPES,
} from '../../../common/services/DefaultValuesUtils';

function ViewFieldData({
  referralSetting,
  index,
  referralSettings,
  handleChange,
  handleSortChange,
  removeField,
  type,
}) {
  return (
    <>
      {/* Sort */}
      <Grid item xs={0.8} sx={{ display: 'flex', justifyContent: 'left' }}>
        <Stack direction="row">
          {index > 0 && (
            <MyIconButton
              color="text.secondary"
              label="Up"
              onClick={e => {
                e.stopPropagation();
                handleSortChange(index, referralSettings, 'up', type);
              }}
            >
              <IconArrowUp size={16} />
            </MyIconButton>
          )}
          {index < referralSettings.length - 1 && (
            <MyIconButton
              color="text.secondary"
              label="Down"
              onClick={e => {
                e.stopPropagation();
                handleSortChange(index, referralSettings, 'down', type);
              }}
            >
              <IconArrowDown size={16} />
            </MyIconButton>
          )}
        </Stack>
      </Grid>

      {/* Required */}
      <Grid item xs={0.8} sx={{ textAlign: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={referralSetting.required}
              disabled={referralSetting.kind === 'label'}
              onChange={event =>
                handleChange(
                  index,
                  event.target.checked,
                  'required',
                  referralSettings,
                  type,
                )
              }
            />
          }
          label=""
        />
      </Grid>

      {/* Hidden / Remove */}
      {!DEFAULT_ORIGINAL_FIELDS.includes(referralSetting.field) ? (
        <Grid item xs={0.8} sx={{ textAlign: 'center' }}>
          <MyIconButton
            color="error"
            label="Remove Field"
            onClick={e => {
              e.stopPropagation();
              removeField(referralSetting, index, type);
            }}
          >
            <IconX size={16} />
          </MyIconButton>
        </Grid>
      ) : (
        <Grid item xs={0.8} sx={{ textAlign: 'center' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={referralSetting.hidden}
                disabled={referralSetting.kind === 'label'}
                onChange={event =>
                  handleChange(
                    index,
                    event.target.checked,
                    'hidden',
                    referralSettings,
                    type,
                  )
                }
              />
            }
            label=""
          />
        </Grid>
      )}

      {/* Size */}
      <Grid item xs={0.8} sx={{ mt: '23px' }}>
        <MyTextField
          value={referralSetting.size}
          type="number"
          InputProps={{ inputProps: { min: 1, max: 12 } }}
          onChange={e =>
            handleChange(index, e.target.value, 'size', referralSettings, type)
          }
          placeholder="Enter Size"
          error={referralSetting.size === ''}
          helperText={referralSetting.size === '' ? 'Empty size!' : ' '}
          fullWidth
          disabled={referralSetting.kind === 'label'}
        />
      </Grid>

      {/* Field Type */}
      <Grid item xs={1.8}>
        <MyTextField
          select
          value={referralSetting.kind}
          onChange={e => {
            console.log(e.target);
            const v = e.target.value;
            handleChange(index, v, 'kind', referralSettings, type);
          }}
          fullWidth
        >
          {FIELD_TYPES.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </MyTextField>
      </Grid>

      {/* Field Name */}
      <Grid item xs={1.8} sx={{ mt: '23px' }}>
        <MyTextField
          value={referralSetting.field}
          onChange={e =>
            handleChange(index, e.target.value, 'field', referralSettings, type)
          }
          placeholder="Enter Field Name"
          error={referralSetting.field === ''}
          helperText={referralSetting.field === '' ? 'Empty field name!' : ' '}
          fullWidth
        />
      </Grid>

      {/* Label */}
      <Grid item xs={1.8} sx={{ mt: '23px' }}>
        <MyTextField
          value={referralSetting.label}
          onChange={e =>
            handleChange(index, e.target.value, 'label', referralSettings, type)
          }
          placeholder="Enter Label"
          error={referralSetting.label === ''}
          helperText={referralSetting.label === '' ? 'Empty label!' : ' '}
          fullWidth
        />
      </Grid>

      {/* Choices */}
      <Grid item xs={3.4}>
        {(referralSetting.kind === 'single_choice' ||
          referralSetting.kind === 'multiple_choice') && (
            <ChoicesOptions
              value={isEmpty(referralSetting.choices) ? [] : referralSetting.choices}
              name="choices"
              onChange={value =>
                handleChange(index, value, 'choices', referralSettings, type)
              }
            />
          )}
      </Grid>
    </>
  );
}

export default function ReferralConfigurableForm({
  referralSettings = [],
  handleChange,
  removeField,
  handleSortChange,
  type = '',
}) {
  return (
    <Paper
      sx={{
        mt: 3,
        p: 0,
        borderRadius: 2,
        width: '100%',
        border: 1,
        borderColor: '#ebe6e7',
        overflow: 'hidden',
      }}
    >
      {/* Header Row */}
      <Grid
        container
        spacing={0.8}
        alignItems="center"
        sx={{
          background: '#fbf9fa',
          borderBottom: 1,
          borderColor: '#ebe6e7',
          pl:4,
          py: 2
        }}
      >
        <Grid item xs={0.8}>
          <MyTypography>Sort</MyTypography>
        </Grid>
        <Grid item xs={0.8}>
          <MyTypography>Required</MyTypography>
        </Grid>
        <Grid item xs={0.8}>
          <MyTypography>Hidden / Remove</MyTypography>
        </Grid>
        <Grid item xs={0.8}>
          <MyTypography>Size</MyTypography>
        </Grid>
        <Grid item xs={1.8}>
          <MyTypography>Field Type</MyTypography>
        </Grid>
        <Grid item xs={1.8}>
          <MyTypography>Field Name</MyTypography>
        </Grid>
        <Grid item xs={1.8}>
          <MyTypography>Label</MyTypography>
        </Grid>
        <Grid item xs={3.4}>
          <MyTypography>Choices</MyTypography>
        </Grid>
      </Grid>

      {/* Data Rows */}
      <Grid container spacing={0.8} alignItems="center" sx={{ p: 2}}>
        {!isEmpty(referralSettings) &&
          referralSettings.map((referralSetting, index) => (
            <ViewFieldData
              key={`ref-field-${index}`}
              referralSettings={referralSettings}
              referralSetting={referralSetting}
              index={index}
              handleChange={handleChange}
              handleSortChange={handleSortChange}
              removeField={removeField}
              type={type}
            />
          ))}
      </Grid>
    </Paper>
  );
}
